import * as React from 'react';
import {AppState} from "../../store";
import {connect} from "react-redux";
import FuseSelect, {ISelectedOption, ISelectOption} from "../../components/FuseSelect";
import {Dispatch} from "redux";
import {SelectValue} from "antd/lib/select";
import remergeCondition from "../../firebase/conditions";
import {withAuthorization} from "../../firebase/withAuthorization";
import {RouteComponentProps, withRouter} from "react-router";
import {
    areAdsFetched,
    areCampaignsFetched,
    areOrganizationsFetched, selectActiveAd, selectActiveCampaigns, selectActiveOrganization,
    selectAdsFilter,
    selectCampaignsFilter,
    selectOrganizationsFilter, selectVisibleCampaignOptions,
    selectVisibleOrganizationsOptions
} from "../../store/organizations/selectors";
import {
    ISetActiveCampaignIdsActionPayload,
    ISetActiveOrganizationIdActionPayload,
    ISetActiveOrganizationIdWithActiveCampaignIdActionPayload, ISetAdsFilterActionPayload,
    ISetCampaignsFilterActionPayload,
    ISetOrganizationsFilterActionPayload,
    setActiveCampaignIdsAction,
    setActiveOrganizationIdAction,
    setActiveOrganizationIdWithActiveCampaignIdAction,
    setAdsFilterAction,
    setCampaignsFilterAction,
    setOrganizationsFilterAction,
} from "../../store/organizations/actions";
import {
    AdsFilter,
    Campaign,
    CampaignsFilter, Organization,
    OrganizationsFilter,
    OrganizationsState,
    Ads as Ad
} from "../../store/organizations/types";
import AdsPreviewer from "./AdsPreviewer";
import styles from './Ads.module.less'
import {Button, Checkbox} from 'antd';
import {CheckboxChangeEvent} from "antd/es/checkbox";
import {addingNewBannerTemplateAction} from "../../store/banner/template/actions";
import {IBannerTemplate} from "../../store/banner/template/types";
import BasicLayout from "../../layout/BasicLayout";

interface IOwnProps extends RouteComponentProps {

}

interface IStoreProps {
    organizationsFilter: OrganizationsFilter,
    campaignsFilter: CampaignsFilter,
    adsFilter: AdsFilter,
    organizations: OrganizationsState;
    organizationsOptions: ISelectOption[];
    campaignsOptions: ISelectOption[];
    areOrganizationsFetched: boolean;
    areAdsFetched: boolean;
    areCampaignsFetched: boolean;
    activeOrganization: Organization;
    activeAd: Ad;
    activeCampaigns: Campaign[];
}

interface IDispatchProps {
    setActiveOrganizationId: (params: ISetActiveOrganizationIdActionPayload) => void
    setActiveOrganizationIdWithActiveCampaignId: (params: ISetActiveOrganizationIdWithActiveCampaignIdActionPayload) => void
    setActiveCampaignIds: (params: ISetActiveCampaignIdsActionPayload) => void
    setOrganizationsFilter: (params: ISetOrganizationsFilterActionPayload) => void
    setCampaignsFilter: (params: ISetCampaignsFilterActionPayload) => void
    setAdsFilter: (params: ISetAdsFilterActionPayload) => void;
    addingNewBannerTemplateAction: (template: IBannerTemplate) => void;
}

type IProps = IOwnProps & IStoreProps & IDispatchProps;

class Ads extends React.Component<IProps> {

    componentDidMount(): void {
        const query = new URLSearchParams(this.props.history.location.search);
        let organizationId = query.get("organization_id");
        let campaignId = query.get("campaign_id");
        if (organizationId && campaignId) {
            this.props.setActiveOrganizationIdWithActiveCampaignId({
                organizationId: organizationId,
                campaignId: campaignId
            })
        } else if (organizationId) {
            this.props.setActiveOrganizationId({organizationId: organizationId})
        } else if (campaignId) {
            this.props.setActiveCampaignIds({campaignIds: [campaignId]})
        }
    }

    onOrganizationChange = (selectedValue: SelectValue) => {
        if (selectedValue === "" || selectedValue === undefined) {
            const query = new URLSearchParams(this.props.history.location.search);
            query.delete("organization_id");
            query.delete("campaign_id");
            this.props.setActiveCampaignIds({campaignIds: []});
            this.props.setActiveOrganizationId({organizationId: ""});
            this.props.history.replace({...this.props.history.location, search: query.toString()})
        }
    };

    onOrganizationSelect = (selectedValue: SelectValue, option: ISelectedOption) => {
        this.props.setActiveOrganizationId({organizationId: selectedValue as string});
        this.props.setActiveCampaignIds({campaignIds: []});
        const query = new URLSearchParams(this.props.history.location.search);
        query.set("organization_id", selectedValue as string);
        query.delete("campaign_id");
        this.props.history.replace({...this.props.history.location, search: query.toString()})
    };

    onCampaignChange = (selectedValue: SelectValue) => {
        if (selectedValue === "" || selectedValue === undefined) {
            const query = new URLSearchParams(this.props.history.location.search);
            query.delete("campaign_id");
            this.props.setActiveCampaignIds({campaignIds: []});
            this.props.history.replace({...this.props.history.location, search: query.toString()})
        }
    };

    onCampaignSelect = (selectedValue: SelectValue, option: ISelectedOption) => {
        this.props.setActiveCampaignIds({campaignIds: [selectedValue as string]});
        // https://github.com/ReactTraining/react-router/issues/5870
        const query = new URLSearchParams(this.props.history.location.search);
        query.set("campaign_id", selectedValue as string);
        this.props.history.replace({...this.props.history.location, search: query.toString()})
    };

    onToggleActiveOrganization = (e: CheckboxChangeEvent): void => {
        if (e.target.checked) {
            this.props.setOrganizationsFilter({filter: OrganizationsFilter.SHOW_ACTIVE})
        } else {
            this.props.setOrganizationsFilter({filter: OrganizationsFilter.SHOW_ALL})
        }
    };

    onToggleActiveCampaign = (e: CheckboxChangeEvent): void => {
        if (e.target.checked) {
            this.props.setCampaignsFilter({filter: CampaignsFilter.SHOW_ACTIVE})
        } else {
            this.props.setCampaignsFilter({filter: CampaignsFilter.SHOW_ALL})
        }
    };

    onToggleActiveAds = (e: CheckboxChangeEvent): void => {
        if (e.target.checked) {
            this.props.setAdsFilter({filter: AdsFilter.SHOW_ACTIVE})
        } else {
            this.props.setAdsFilter({filter: AdsFilter.SHOW_ALL})
        }
    };

    render() {
        const header = <React.Fragment>
            {
                this.props.areOrganizationsFetched &&
                <span className={styles.selectSpan}>
                    <FuseSelect
                        placeholder="Type to select Organization..."
                        options={this.props.organizationsOptions}
                        defaultValue={this.props.organizations.activeOrganizationId}
                        onSelect={this.onOrganizationSelect}
                        onChange={this.onOrganizationChange}
                    />
                </span>
            }
            {
                this.props.areCampaignsFetched &&
                <span className={styles.selectSpan}>
                    <FuseSelect
                        placeholder="Type to select Campaign..."
                        options={this.props.campaignsOptions}
                        defaultValue={this.props.organizations.activeCampaignIds}
                        onSelect={this.onCampaignSelect}
                        onChange={this.onCampaignChange}
                    />
                </span>
            }
            <Checkbox
                onChange={this.onToggleActiveOrganization}
                checked={this.props.organizationsFilter === OrganizationsFilter.SHOW_ACTIVE}
            >
                Active Organization
            </Checkbox>
            <Checkbox
                onChange={this.onToggleActiveCampaign}
                checked={this.props.campaignsFilter === CampaignsFilter.SHOW_ACTIVE}
            >
                Active Campaigns
            </Checkbox>

        </React.Fragment>
        return (
            <BasicLayout header={header}>
                <div className={styles.rootContainer}>
                   {
                        this.props.areAdsFetched && <AdsPreviewer/>
                    }
                </div>
            </BasicLayout>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    organizationsFilter: selectOrganizationsFilter(state),
    campaignsFilter: selectCampaignsFilter(state),
    adsFilter: selectAdsFilter(state),
    areOrganizationsFetched: areOrganizationsFetched(state),
    areCampaignsFetched: areCampaignsFetched(state),
    areAdsFetched: areAdsFetched(state),
    organizations: state.organizations,
    activeOrganization: selectActiveOrganization(state),
    activeCampaigns: selectActiveCampaigns(state),
    activeAd: selectActiveAd(state),
    campaignsOptions: selectVisibleCampaignOptions(state),
    organizationsOptions: selectVisibleOrganizationsOptions(state)
});

const mapDispatchToProps = (
    dispatch: Dispatch
): IDispatchProps => {
    return {
        setActiveOrganizationId: (params: ISetActiveOrganizationIdActionPayload) => dispatch(setActiveOrganizationIdAction(params)),
        setActiveOrganizationIdWithActiveCampaignId: (params: ISetActiveOrganizationIdWithActiveCampaignIdActionPayload) => dispatch(setActiveOrganizationIdWithActiveCampaignIdAction(params)),
        setActiveCampaignIds: (params: ISetActiveCampaignIdsActionPayload) => dispatch(setActiveCampaignIdsAction(params)),
        setOrganizationsFilter: (params: ISetOrganizationsFilterActionPayload) => dispatch(setOrganizationsFilterAction(params)),
        setCampaignsFilter: (params: ISetCampaignsFilterActionPayload) => dispatch(setCampaignsFilterAction(params)),
        setAdsFilter: (params: ISetAdsFilterActionPayload) => dispatch(setAdsFilterAction(params)),
        addingNewBannerTemplateAction: (template: IBannerTemplate) => dispatch(addingNewBannerTemplateAction({template: template})),
    };
};

const authCondition = (authUser: any) => remergeCondition(authUser);

const connected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Ads);

export default withAuthorization(authCondition)(withRouter(connected));


